import { pick } from 'shared/utils/objectUtils'
import { parseUrl } from 'query-string'

export const SEARCH_PARAMS = ['query', 'queryID', 'position']

export const extractSearchParams = url => {
  return pick(parseUrl(url).query, SEARCH_PARAMS)
}
